var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"elevation":"3","className":"ma-4"}},[_c('admin-page')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }